import {
    GST_LEDGER_REPORT_REQUEST,
    GST_LEDGER_REPORT_SUCCESS,
    GST_LEDGER_REPORT_FAILURE,
  } from "../types/gst-ledger-report-types.js";
  
  const initialState = {
    gstLedgerReport: {},
    loading: false,
    error: null,
  };
  
  const GstLedgerReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case GST_LEDGER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case GST_LEDGER_REPORT_SUCCESS: {
        return {
          ...state,
          gstLedgerReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case GST_LEDGER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default GstLedgerReportReducer;
  